import { el } from "./dom";

// The stage strip at the top of a module (brief 1A-6, mockup flowCard and .trail): a titled
// card with one numbered step after another, each with its count and a one-line description.
// A step opens its screen when the person can open it.

export interface StageStep {
  /** e.g. "1 Client" (the number is part of the title, as in the mockup). */
  title: string;
  count: number | string;
  line: string;
  /** Where the step goes; without it the step is plain text. */
  go?: () => void;
}

export interface StageStrip {
  title: string;
  /** A small line under the title (mockup: "Each step hands off to the next."). */
  lane?: string;
  steps: StageStep[];
}

export function stageStrip(def: StageStrip): HTMLElement {
  const steps = def.steps.map((s) => {
    const parts = [
      el("span", { class: "k" }, s.title),
      el("span", { class: "v" }, String(s.count)),
      el("span", { class: "s" }, s.line),
    ];
    if (!s.go) return el("div", { class: "step" }, ...parts);
    const b = el("button", { type: "button" }, ...parts);
    b.addEventListener("click", s.go);
    return b;
  });
  return el(
    "section",
    { class: "card", "aria-label": def.title },
    el("div", { class: "eyebrow", style: "margin-bottom:8px" }, def.title),
    def.lane ? el("div", { class: "small muted", style: "margin:-4px 0 6px" }, def.lane) : null,
    el("div", { class: "trail", style: `--steps:${steps.length}` }, ...steps),
  );
}
